<!-- Popover Menu -->
<mat-menu #profileMenu="matMenu" class="popover">
  <div class="menu-title">PROFILE</div>
  @if (isAdmin) {
    <button mat-menu-item class="menu-item" [routerLink]="['/admin-panel']">Admin Panel</button>
  }
  @if (canAddProduct) {
    <button mat-menu-item class="add-product-button menu-item" (click)="openAddProductDialog()" data-cypress="add-product-button">Add Product</button>
  }
  @if (canAddDataProduct) {
    <button mat-menu-item class="add-product-button menu-item" (click)="openAddDataProductDialog()">Add Data Product</button>
  }
  @if (canAddProgram) {
    <button mat-menu-item class="add-program-button menu-item" (click)="openAddProgramDialog()">Add Program</button>
  }
  @if (canAddEnablerProject && canAddProduct) {
    <button mat-menu-item class="add-enabler-button menu-item" (click)="openAddEnablerItemDialog()">Add Enabler Item</button>
  }
  @if (canAddEnablerProject && !canAddProduct) {
    <button mat-menu-item class="add-enabler-button menu-item" (click)="openAddEnablerProject()">Add Enabler Project</button>
  }
  @if (canAddProduct && !canAddEnablerProject) {
    <button mat-menu-item class="add-enabler-button menu-item" (click)="openAddProduct()">Add Enabler Product</button>
  }
  @if (isWriterRightsManagement) {
    <button mat-menu-item class="rights-management-button menu-item" [routerLink]="['/rights-management']">Rights management</button>
  }
  <button mat-menu-item class="logout-button menu-item" (click)="logout()">Log Out</button>
</mat-menu>
